import Vector from "./vector";
export class VariableSizeVector extends Vector {
    offsetBuffer;
    //TODO: switch to Uint32Array by changing the decodings
    constructor(name, offsetBuffer, dataBuffer, sizeOrNullabilityBuffer) {
        super(name, dataBuffer, sizeOrNullabilityBuffer);
        this.offsetBuffer = offsetBuffer;
    }
}
//# sourceMappingURL=variableSizeVector.js.map